import React from 'react'
import classNames from 'classnames'
import type { Props } from './types'
import styles from './style.module.scss'

const Label: React.FC<Props> = ({
  text,
  placement,
  hidden,
  type,
  clickHandler,
}) => {
  const classes = classNames(
    styles['label'],
    [
      [styles[`align--h-${placement.HorizontalAlignment}`]],
      [styles[`align--v-${placement.VerticalAlignment}`]],
      [styles[`type--${type}`]],
    ],
    {
      [styles['is-hidden']]: hidden,
      [styles['clickable']]: clickHandler,
    }
  )

  return (
    <label className={classes} onClick={() => clickHandler && clickHandler()}>
      <span
        style={{
          top: `${(placement.VerticalOffset || 0) / 10}rem`,
          left: `${(placement.HorizontalOffset || 0) / 10}rem`,
        }}
      >
        {text}
      </span>
    </label>
  )
}

export default Label
